import type { CardFormData } from '@/lib/card-payment-entry';
import {
    detectCardBrandConfiguration,
    formatCardNumber,
    formatExpiryDate,
} from '@/lib/card-payment-entry';

type FullyOwnedInvoiceCardEntryProps = {
    value: CardFormData;
    disabled: boolean;
    onChange: (value: CardFormData) => void;
};

export function FullyOwnedInvoiceCardEntry({
    value,
    disabled,
    onChange,
}: FullyOwnedInvoiceCardEntryProps) {
    return (
        <div className="grid gap-4 md:grid-cols-2">
            <label className="space-y-2 text-sm font-medium text-slate-700">
                Card Number
                <input
                    type="text"
                    value={value.cardNumber}
                    onChange={(event) =>
                        onChange({
                            ...value,
                            cardNumber: formatCardNumber(event.target.value),
                        })
                    }
                    placeholder="0000 0000 0000 0000"
                    className="w-full rounded-md border border-slate-300 px-3 py-2 text-base text-slate-900"
                    readOnly={disabled}
                />
            </label>

            <label className="space-y-2 text-sm font-medium text-slate-700">
                Cardholder Name
                <input
                    type="text"
                    value={value.cardholderName}
                    onChange={(event) => onChange({ ...value, cardholderName: event.target.value })}
                    placeholder="Name on card"
                    className="w-full rounded-md border border-slate-300 px-3 py-2 text-base text-slate-900"
                    readOnly={disabled}
                />
            </label>

            <label className="space-y-2 text-sm font-medium text-slate-700">
                Expiration Date
                <input
                    type="text"
                    value={value.expiryDate}
                    onChange={(event) =>
                        onChange({ ...value, expiryDate: formatExpiryDate(event.target.value) })
                    }
                    placeholder="MM/YY"
                    className="w-full rounded-md border border-slate-300 px-3 py-2 text-base text-slate-900"
                    readOnly={disabled}
                />
            </label>

            <label className="space-y-2 text-sm font-medium text-slate-700">
                Security Code
                <input
                    type="text"
                    value={value.cvv}
                    onChange={(event) => {
                        const maxLength =
                            detectCardBrandConfiguration(value.cardNumber)?.securityCodeLength ?? 4;
                        onChange({
                            ...value,
                            cvv: event.target.value.replace(/\D/g, '').slice(0, maxLength),
                        });
                    }}
                    placeholder="CVV"
                    className="w-full rounded-md border border-slate-300 px-3 py-2 text-base text-slate-900"
                    readOnly={disabled}
                />
            </label>
        </div>
    );
}
